import { Layout, EmptyLayout } from '@/utils/routerHelper'
import { useI18n } from '@/hooks/web/useI18n'

const { t } = useI18n()

export const helpRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/help',
    component: Layout,
    name: 'help',
    // redirect: '/help/help',
    meta: {
      hidden: true,
      title: '帮助文档',
      noTagsView: true
    },
    children: [
      {
        path: 'help',
        component: () => import('@/views/HelpDocument/index.vue'),
        name: 'helpFirst',
        meta: {
          hidden: true,
          title: '帮助手册',
          noTagsView: true,
          permissionCode: 'HELP10001'
        }
      }
    ]
  }
]
